import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function RouteChangeTracker() {
  const location = useLocation();
  
  useEffect(() => {
    try {
      // Get current hostname without port number
      const currentHostname = window.location.hostname.split(':')[0];
      
      // Known development hostnames
      const knownDevURLs = [
        'zp1v56uxy8rdx5ypatb0ockcb9tr6a-oci3-nuegj1mr',
        'sb1qykhapp2-1y2q',
        'zp1v56uxy8rdx5ypatb0ockcb9tr6a-oci3-m6gkswig',
        'zp1v56uxy8rdx5ypatb0ockcb9tr6a-oci3',
        'localhost'
      ];
      
      // Check if current hostname matches any development URL pattern
      const isDevelopment = knownDevURLs.some(url => currentHostname.includes(url)) || 
                           currentHostname.includes('local-credentialless.webcontainer');
      
      if (isDevelopment) {
        // Safely construct the URL
        const pageUrl = new URL(window.location.pathname, window.location.origin);
        const safeUrl = encodeURI(pageUrl.toString());
        
        // Send page view event to dataLayer
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'page_view',
            page_title: document.title,
            page_location: safeUrl,
            page_path: encodeURI(pageUrl.pathname),
            page_hostname: encodeURI(currentHostname)
          });
        }
      }
    } catch (error) {
      console.warn('Error tracking page view:', error);
    }
  }, [location]);
  
  return null;
}